import { apiClient } from "./client";

export const getOrders = ({ page = 1, limit = 10, search = "" } = {}) => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit)
  });

  if (search.trim()) {
    query.set("search", search.trim());
  }

  return apiClient.get(`/admin/orders?${query.toString()}`);
};

export const getOrderById = (orderId) => {
  return apiClient.get(`/admin/orders/${orderId}`);
};

export const acknowledgeOrder = (orderId) => {
  return apiClient.post(`/admin/orders/${orderId}/acknowledge`, {});
};

export const rejectOrder = (orderId, reason) => {
  return apiClient.post(`/admin/orders/${orderId}/reject`, { reason });
};

export const updateOrderTotal = (orderId, total_amount) => {
  return apiClient.put(`/admin/orders/${orderId}/total`, { total_amount });
};
